// extracted by mini-css-extract-plugin
module.exports = {"warningWrapper":"AutoRefreshDisableHack_warning-wrapper__0REG5"};